const countyConfigLanguagesReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_LANGUAGES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigLanguagesReducer;